import React from 'react'
import PropTypes from 'prop-types'
import { useFormContext } from 'react-hook-form'

import { InputWrapperDiv } from '../styles/Containers'
import { TextField } from '../styles/TextField'
import Label from './Label'

const getError = (id, errors) => {
  return id.split('.').reduce((o, i) => {
    const exists = o[i] !== undefined
    if (!exists) return {}
    return o[i]
  }, errors)
}

const FormInput = ({
  required = false,
  id,
  label = '',
  basis,
  props,
  inputProps,
  multiline = false,
  disabled = false,
  tooltip = '',
  minRows,
  minwidth,
  textFieldFormat = 'default'
}) => {
  const { register, formState } = useFormContext()

  const errors = formState.errors
  const error = getError(id, errors)

  return (
    <InputWrapperDiv basis={basis} minwidth={minwidth}>
      <TextField
        {...register(id)}
        id={id}
        name={id}
        label={<Label label={label} tooltip={tooltip} />}
        variant="standard"
        InputLabelProps={{
          shrink: true,
          required,
          focused: false
        }}
        InputProps={{
          disableUnderline: true,
          ...inputProps
        }}
        disabled={disabled}
        multiline={multiline}
        minRows={multiline ? minRows : 1}
        error={Object.keys(error).length > 0 && !!error}
        helperText={error?.message}
        FormHelperTextProps={{ role: 'alert' }}
        haslabel={label === '' ? 'false' : 'true'}
        styleformat={textFieldFormat}
        {...props}
      />
    </InputWrapperDiv>
  )
}

FormInput.propTypes = {
  id: PropTypes.string.isRequired,
  required: PropTypes.bool,
  label: PropTypes.string,
  basis: PropTypes.string,
  props: PropTypes.object,
  inputProps: PropTypes.object,
  multiline: PropTypes.bool,
  disabled: PropTypes.bool,
  tooltip: PropTypes.string,
  minRows: PropTypes.number,
  minwidth: PropTypes.string,
  textFieldFormat: PropTypes.oneOf(['default', 'condensed'])
}

export default FormInput
